<script>
    import {PATH_PREFIX} from '../../apiUrls.js';
  
    import {array, object, string} from 'yup';
    import {validateForm} from '../Form/utils.js';
    import Errors from '../Errors.svelte';
    import {get, post} from '../../utils.js';
    import {sgettext} from '../../i18n.js';
    import InfoTooltip from '../common/InfoTooltip.svelte';
  
    export let activityId = null;
    export let canEditEmailRecipients = false;

    let disabled = false;
    let activity_email_recipients_parent_div = document.getElementById('id_activity_email_summary_recipients');
    
    let mutationObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if(mutation.target === activity_email_recipients_parent_div) {
                disabled = activity_email_recipients_parent_div.hasAttribute('disabled');
            }
        });
    });

    mutationObserver.observe(activity_email_recipients_parent_div, {
        attributes: true,
    });
    
    let originalEmails = null;
    let emails = null;
    let emailsToAdd = "";
    
    let schema = object().shape({
      user_email: array().of(string().email().required()),
    });

    let formErrors = [];
  
    $: activityEmailGroupUrl = `${PATH_PREFIX}/old/sw/administration/user-email-groups/activity/${activityId}/`

    async function handleAdd() {
        try {
            let emailsAdded = false;
            let emailList = emailsToAdd.toLowerCase().split(";").map(email => email.trim())
            await validateForm(schema, {user_email: emailList});

            for (let emailToAdd of emailList) {
                if (emailToAdd.split("@")[1].toLowerCase() !== "bhp.com") {
                    formErrors = sgettext("$$VALID_EMAIL_ADDRESSES_END_BHPCOM$$")
                    continue;
                } else if (emails.has(emailToAdd)) {
                    if (emailList.length == 1) emailsToAdd = "";
                    continue;
                } else {
                    formErrors = "";
                    emails.add(emailToAdd);
                    emailsAdded = true;
                }
            }
            emailsToAdd = "";
            if (!emailsAdded) return;
            await handleSaveChanges();
        } 
        catch(err) {
            formErrors = sgettext('$$PLEASE_ENTER_VALID_EMAIL_ADDRESS$$');
        }
    }

    async function handleRemove(emailToRemove) {
        emails.delete(emailToRemove);
        await handleSaveChanges();
    }
  
    async function handleSaveChanges() {  
        try {
            const response = await post(activityEmailGroupUrl, {
                emails: Array.from(emails),
            });
    
            if (response.ok) {
                const res = await response.json();
                emails = new Set(res.emails);
            }
            else {
                emails = originalEmails;
                const err = await response.json();
                if (err.hasOwnProperty('error')) {
                    formErrors = err.error;
                }
            }
        }
        catch(err) {
            formErrors = sgettext('$$SOMETHING_WENT_WRONG_UPDATING_EMAIL_1$$');
        }
        finally {
            emailsToAdd = "";
        } 
    }

    async function getEmailGroupUsersForActivity(url) {
        if (!activityId) {
            emails = [];
            return;
        }

        try {
            const response = await get(url);
            if (response.ok) {
                const res = await response.json();
                originalEmails = new Set(res.emails);
                emails = new Set(res.emails);
            } else {
                const err = await response.json();
                if (err.hasOwnProperty('error')) {
                    formErrors = err.error;
                }
            }
        }
        catch(err) {
            formErrors = sgettext('$$SOMETHING_WENT_WRONG_FETCHING_EMAIL$$');
        }
    }

    $: getEmailGroupUsersForActivity(activityEmailGroupUrl);
</script>

<div class="mt-3">
  {#if formErrors && formErrors.length > 0}
    <Errors errors={formErrors} />
  {/if}
  <p class="secondary-label text-secondary mb-0">
    {sgettext('$$CONFIGURED_ACTIVITY_1$$').toUpperCase()}
    <InfoTooltip
      tooltipText={sgettext(
        '$$FOLLOWING_EMAILS_CONFIGURED_SPECIFICAL_1$$'
      )}
    />
  </p>
  {#if !disabled && canEditEmailRecipients}
    <form on:submit|preventDefault={handleAdd}>
      <div class="form-group">
        <div class="d-flex justify-content-between">
          <input
            id="userEmails"
            class="form-control mr-2"
            type="email"
            bind:value={emailsToAdd}
          />
          <button
            class="btn btn-primary ml-2"
            style="white-space: nowrap;"
            on:click|preventDefault={handleAdd}
            disabled={emailsToAdd.length == 0}
          >
            {sgettext('$$ADD_1$$')}
          </button>
        </div>
        <small class="form-text text-secondary ml-2">
          {sgettext(
            '$$SEPARATE_MULTIPLE_EMAILS_MARK_BHPCOM$$'
          )}
        </small>
      </div>
    </form>
  {/if}
  {#if emails && emails.size > 0}
    <div class="list-group user-list">
      {#each Array.from(emails) as email}
        <div
          class="list-group-item d-flex justify-content-between bg-white p-2 px-3"
        >
          <p class="mb-0">{email}</p>
          {#if !disabled && canEditEmailRecipients}
            <p class="mb-0 mr-3">
              <i
                class="fa fa-trash remove-recipient"
                on:click={() => handleRemove(email)}
              />
            </p>
          {/if}
        </div>
      {/each}
    </div>
  {:else}
    <p class="my-2 ml-2 text-secondary">
      <b>{sgettext('$$EMAIL_RECIPIENTS_CONFIGURED_ACTIVITY_1$$')}</b>
    </p>
  {/if}
</div>

<div class="mt-3">
  {#if formErrors && formErrors.length > 0}
    <Errors errors={formErrors} />
  {/if}
  <p class="secondary-label text-secondary mb-0">
    {sgettext('$$CONFIGURED_ACTIVITY_1$$').toUpperCase()}
    <InfoTooltip
      tooltipText={sgettext(
        '$$FOLLOWING_EMAILS_CONFIGURED_SPECIFICALLY$$'
      )}
    />
  </p>
  {#if !disabled && canEditEmailRecipients}
    <form on:submit|preventDefault={handleAdd}>
      <div class="form-group">
        <div class="d-flex justify-content-between">
          <input
            id="userEmails"
            class="form-control mr-2"
            type="email"
            bind:value={emailsToAdd}
          />
          <button
            class="btn btn-primary ml-2"
            style="white-space: nowrap;"
            on:click|preventDefault={handleAdd}
            disabled={emailsToAdd.length == 0}
          >
            {sgettext('$$ADD_1$$')}
          </button>
        </div>
        <small class="form-text text-secondary ml-2">
          {sgettext(
            '$$SEPARATE_MULTIPLE_EMAILS_USER1NAME$$'
          )}
        </small>
      </div>
    </form>
  {/if}
  {#if emails && emails.size > 0}
    <div class="list-group user-list">
      {#each Array.from(emails) as email}
        <div
          class="list-group-item d-flex justify-content-between bg-white p-2 px-3"
        >
          <p class="mb-0">{email}</p>
          {#if !disabled && canEditEmailRecipients}
            <p class="mb-0 mr-3">
              <i
                class="fa fa-trash remove-recipient"
                on:click={() => handleRemove(email)}
              />
            </p>
          {/if}
        </div>
      {/each}
    </div>
  {:else}
    <p class="my-2 ml-2 text-secondary">
      <b>{sgettext('$$EMAIL_RECIPIENTS_CONFIGURED_ACTIVITY_1$$')}</b>
    </p>
  {/if}
</div>

<style>
  .secondary-label {
    letter-spacing: 1px !important;
    font-size: 0.9rem;
  }

  .user-list {
    max-height: 145px;
    overflow-y: scroll;
  }

  .remove-recipient:hover {
    color: #dd5900;
  }
</style>
